import React from 'react'

export default function NoData() {
    return (
        <div className='w-full flex flex-col justify-center items-center'>
            <span className='text-lg text-gray-800 pt-4'>Nenhum resultado encontrado.</span>
        </div>
    )
}
